// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ActualsCustomerPerformanceSummary {
  readonly id: string;
  readonly name: string;
  readonly actualVolumeMix: string | null;
  readonly actualVolumeAsphalt: string | null;
  readonly actualVolumeAggregate: string | null;
  readonly activeProjects: number | null;
  readonly averageLoadMix: string | null;
  readonly averageLoadAsphalt: string | null;
  readonly averageLoadAggregate: string | null;
  readonly averageWaitTime: string | null;
  readonly averageUnloadTime: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.actualVolumeMix = data.actualVolumeMix === undefined ? null : data.actualVolumeMix;
    this.actualVolumeAsphalt =
      data.actualVolumeAsphalt === undefined ? null : data.actualVolumeAsphalt;
    this.actualVolumeAggregate =
      data.actualVolumeAggregate === undefined ? null : data.actualVolumeAggregate;
    this.activeProjects = data.activeProjects === undefined ? null : data.activeProjects;
    this.averageLoadMix = data.averageLoadMix === undefined ? null : data.averageLoadMix;
    this.averageLoadAsphalt =
      data.averageLoadAsphalt === undefined ? null : data.averageLoadAsphalt;
    this.averageLoadAggregate =
      data.averageLoadAggregate === undefined ? null : data.averageLoadAggregate;
    this.averageWaitTime = data.averageWaitTime === undefined ? null : data.averageWaitTime;
    this.averageUnloadTime = data.averageUnloadTime === undefined ? null : data.averageUnloadTime;
  }

  static zero(): ActualsCustomerPerformanceSummary {
    const zeroValues: ExcludeMethodsDeep<ActualsCustomerPerformanceSummary> = {
      id: NIL_UUID,
      name: '',
      actualVolumeMix: null,
      actualVolumeAsphalt: null,
      actualVolumeAggregate: null,
      activeProjects: null,
      averageLoadMix: null,
      averageLoadAsphalt: null,
      averageLoadAggregate: null,
      averageWaitTime: null,
      averageUnloadTime: null,
    };
    return new ActualsCustomerPerformanceSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsCustomerPerformanceSummaryWireFormat = {
  id: string;
  name: string;
  actualVolumeMix: string | null;
  actualVolumeAsphalt: string | null;
  actualVolumeAggregate: string | null;
  activeProjects: number | null;
  averageLoadMix: string | null;
  averageLoadAsphalt: string | null;
  averageLoadAggregate: string | null;
  averageWaitTime: string | null;
  averageUnloadTime: string | null;
};

type NewActualsCustomerPerformanceSummaryProps = PartialDeep<
  ActualsCustomerPerformanceSummary,
  { recurseIntoArrays: true }
>;
export const NewActualsCustomerPerformanceSummary: (
  props: NewActualsCustomerPerformanceSummaryProps,
) => ActualsCustomerPerformanceSummary = (props) => new ActualsCustomerPerformanceSummary(props);

type NewActualsCustomerPerformanceSummaryFromWireFormatProps = PartialDeep<
  ActualsCustomerPerformanceSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsCustomerPerformanceSummaryFromWireFormat: (
  props: NewActualsCustomerPerformanceSummaryFromWireFormatProps,
) => ActualsCustomerPerformanceSummary = (props) => new ActualsCustomerPerformanceSummary(props);
